"use strict";
document.addEventListener("DOMContentLoaded", function () {
	var e = $("#nav-global .nav-global-item").length,
		t = 50 * e + 100,
		n = 50 * e + 300;
	$(".js-drawer").on("click", function () {
		return $(this).toggleClass("is-active"), $(this).hasClass("is-active") ? ($(this).attr("aria-expanded", "true"), $("body").addClass("is-open"), setTimeout(function () {
			$("body").addClass("is-open-overlay")
		}, t), setTimeout(function () {
			$("body").addClass("is-open-menu")
		}, n)) : ($(this).attr("aria-expanded", "false"), $("body").removeClass("is-open-menu"), setTimeout(function () {
			$("body").removeClass("is-open-overlay")
		}, t), setTimeout(function () {
			$("body").removeClass("is-open")
		}, n)), !1
	})
}), 
	
document.addEventListener("DOMContentLoaded", function () {
	$(".js-target-show").on("click", function () {
		var e = $(this).attr("href");
		return $(e).attr("aria-hidden", "false"), !1
	}), $(".js-target-hide").on("click", function () {
		var e = $(this).attr("href");
		return $(e).attr("aria-hidden", "true"), !1
	})
}),
	
document.addEventListener("DOMContentLoaded", function () {
	var e = ".js-rellax";
	if ($(e).length) {
		if ("sp" == device || "tab" == device) return;
		$(window).on("load", function () {
			imagesLoaded(document.querySelectorAll(e), function () {
				new Rellax(e, {
					speed: -5,
					center: !0
				})
			})
		})
	}
}),
	
document.addEventListener("DOMContentLoaded", function () {
	$(".js-scroll").click(function () {
		var e = $(this).attr("href"),
			t = $("#" == e || "" == e ? "html" : e),
			n = parseInt($(".header").outerHeight()),
			o = t.offset().top - n;
		return $("body,html").animate({
			scrollTop: o
		}, 300, "swing"), !1
	}), $(window).on("load", function () {
		var e = parseInt($(".header").outerHeight()),
			t = $(location).attr("href");
		if (-1 != t.indexOf("?id=")) {
			var n = t.split("?id="),
				o = $("#" + n[n.length - 1]);
			if (o.length) {
				var a = o.offset().top - e;
				$("html, body").animate({
					scrollTop: a
				}, 300)
			}
		}
	})
}),

$(function () {
	$(".js-slider").slick({
		dots: !0,
		appendDots: ".hero-slide-wrap",
		arrows: !1,
		fade: !0,
		infinite: !0,
		speed: 1e3,
		slidesToShow: 1,
		autoplay: !0,
		autoplaySpeed: 3e3
	})
});
